<template>
    <rich-text-page field="cookiePolicy" title="Cookie Policy">
        <template #description>Shown at lavishlocations.com/cookiepolicy.</template>
    </rich-text-page>
</template>

<script>
    import RichTextPage from "../components/rich-text-page";

    export default {
        name: "CookiePolicy",
        components: {RichTextPage},
    }
</script>



// WEBPACK FOOTER //
// src/site-content/CookiePolicy.vue